<template lang="pug">
.sprite.text-left
  .token-id(v-if='tokenId') {{ `#${tokenId}` }}
  strong.name {{ sprite.name }}
  .level Lvl. {{ sprite.level || 0 }}
  sprite-render.sprite-image(:sprite='sprite', :class="{adolescent: sprite.evolution === 1}")
  .progress-wrap
    .progress-item.d-flex.align-items-center
      .exp-title.d-flex.align-items-center.justify-content-center
        span Exp
      .exp-bar-wrap.d-flex.align-items-center
        .exp-fill(:style="{width: `${expPercent}%`}")
  .exp
    span {{ spriteExp - expToPrevLevel }} / {{ expToNextLevel - expToPrevLevel }}
    strong EXP
</template>

<style>
  .sprite-image img {
    margin-bottom: 3rem;
  }

  .adolescent img {
    max-height: 90px;
    margin-bottom: 1rem;
  }
</style>

<style lang="scss" scoped>
  .sprite {
    height: 264px;
    padding: 1rem;
    margin-bottom: 1rem;
    border-radius: 8px;
    background-color: #ffffff;
    transition: box-shadow ease-in .15s;
    box-shadow: 0 2px 2px 0 rgba(31, 31, 31, 0.12), 0 0 2px 0 rgba(31, 31, 31, 0.12);

    .token-id {
      transition: all ease .4s;
      position: absolute;
      text-align: center;
      top: 0;
      right: 15px;
      width: 46px;
      height: 20px;
      border-radius: 0px 8px 0px 8px;
      background-color: #f7f8f6;
      font-size: 10px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.2;
      letter-spacing: normal;
      color: #a1a39e;
      padding-top: .25rem;
    }

    .name {
      font-size: 14px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #363734;
    }

    .sprite-image {
      margin-top: 2rem;
    }

    .level {
      font-size: 12px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: normal;
      color: #a1a39e;
    }

    .progress-wrap {
      position: relative;
      margin-top: 1rem;
      max-width: 140px;
      margin: 0 auto;
    }

    .progress-item {
      width: 100%;
      max-width: 375px;
      height: 16px;
      border-radius: 999px;
      background-color: #e7e9e4;
      margin: 0 auto;
    }

    .exp-title {
      width: 22%;
      height: 100%;
      background: #9bc75a;
      border-radius: 10px 0px 0px 10px;
      margin-right: .2rem;
      font-size: 10px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.2;
      letter-spacing: normal;
      color: #f7f8f6;
      text-align: center;
    }

    .exp-bar-wrap {
      width: 72%;
      height: 8px;
      padding-left: .2rem;
      padding-right: .2rem;
      border-radius: 999px;
      background-color: #ffffff;
    }

    .exp-fill {
      width: 84px;
      max-width: 100%;
      height: 4px;
      border-radius: 999px;
      background-color: #9bc75a;
    }

    .exp {
      font-size: 12px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: normal;
      text-align: center;
      color: #a1a39e;
      margin-top: 1rem;

      span {
        margin-right: .2rem;
      }
    }
  }

  .sprite:hover {
    cursor: pointer;
    box-shadow: 0 4px 8px 0 rgba(31, 31, 31, 0.16), 0 4px 8px 0 rgba(31, 31, 31, 0.24);
  }
</style>

<script>
import spriteStats from '../../mixins/spriteStats';
import SpriteRender from '../monsters/SpriteRender';

export default {
  props: ['sprite'],
  mixins: [spriteStats],
  components: {
    SpriteRender,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/mysprites/MySpriteItem.vue